export default __webpack_public_path__ + "static/media/Slide8.b98d5799.jpg";